export * from './verify-person-alert-configs';

